import CalcalistPaywallMyAccountPersonalDetails from "./calcalistPaywallMyAccountPersonalDetails"
import CalcalistPaywallMyAccountLastPurchases from "./calcalistPaywallMyAccountpLastPurchases"
import CalcalistPaywallMyAccountTabs from "./calcalistPaywallMyAccountTabs";
import { useEffect, useState } from "react";
import { useRedirect } from "../../../../../global/paywall/useRedirect";
import { LinkTargetProperties } from "../../../../../global/components/linkSettings/interfaces"
import { DetailsUpdateMode, DetailUpdateError, useDetailsUpdate } from "../../../../../global/paywall/useDetailsUpdate";
import PaywallRevalidate from "../../../paywallRevalidate/desktop/paywallRevalidate";
import { AuthLogOutLocal } from "../../../../../global/paywall/authOperations";

const CalcalistPaywallMyAccountComponenta = (props: { authPageUrl: string, contactUsPage:{url:string,targetLink:LinkTargetProperties} }) => {
    const { authPageUrl, contactUsPage} = props;
    const {
        customerDetails,
        setStateCustomerDetails,
        revalidationType,
        setRevalidationType,
        error,
        revalidateUser,
        saved,
        revalidationStep,
        saveCustomerDetails,
        sendRevalidation,
        validateOtp
    } = useDetailsUpdate(DetailsUpdateMode.MY_ACCOUNT);
    const [shouldRedirect, setShouldRedirect] = useState(false);
    useRedirect({ fallbackUrl: authPageUrl, enabled: shouldRedirect });

        useEffect(() => {
            if (error === DetailUpdateError.NOT_LOGGED_IN) {
                setShouldRedirect(true);
                AuthLogOutLocal();
            }
        }, [error]);

    useEffect(() => {
        const userAgent = navigator.userAgent;
        const isIpadDevice = /iPad/.test(userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
        if (isIpadDevice) {
            document.body.classList.add('ipad-device');
        }
    }, []);

    
        if (revalidateUser) {
            return <PaywallRevalidate
                userData={revalidateUser}
                step={revalidationStep}
                error={error}
                revalidationType={revalidationType}
                setRevalidationType={setRevalidationType}
                sendRevalidation={sendRevalidation}
                validateOtp={validateOtp}
            />;
        }
    


    const tabs = [
        {
            label: "המשתמש שלי",
            content: <CalcalistPaywallMyAccountPersonalDetails 
                setStateCustomerDetails={setStateCustomerDetails}
                customerDetails={customerDetails}
                saveCustomerDetails={saveCustomerDetails}
                error={error}
                saved={saved} />,
        },
        {
            label: "רכישות אחרונות",
            content: <CalcalistPaywallMyAccountLastPurchases userData={customerDetails} contactUsPage={contactUsPage} />,
        },
    ];

    return (
        <div className="CalcalistPaywallMyAccountComponenta">
            { customerDetails && <CalcalistPaywallMyAccountTabs tabs={tabs} contactUsPage={contactUsPage} />}
        </div>
    );

};

export default CalcalistPaywallMyAccountComponenta;

CalcalistPaywallMyAccountComponenta.siteScriptName = "CalcalistPaywallMyAccountComponenta"

